import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    inlineBlocks: {
      create: 'أنشئ {{label}}',
      edit: 'تحرير {{label}}',
      label: 'الكتل الداخلية',
      remove: 'إزالة {{label}}',
    },
    label: 'كتل',
  },
  az: {
    inlineBlocks: {
      create: 'Yarat {{label}}',
      edit: '{{label}} redaktə et',
      label: 'Sıralı Bloklar',
      remove: '{{label}} silin',
    },
    label: 'Bloklar',
  },
  bg: {
    inlineBlocks: {
      create: 'Създайте {{label}}',
      edit: 'Редактирай {{label}}',
      label: 'Вградени блокове',
      remove: 'Премахнете {{label}}',
    },
    label: 'Блокове',
  },
  cs: {
    inlineBlocks: {
      create: 'Vytvořte {{label}}',
      edit: 'Upravit {{label}}',
      label: 'Inline bloky',
      remove: 'Odstraňte {{label}}',
    },
    label: 'Bloky',
  },
  da: {
    inlineBlocks: {
      create: 'Opret {{label}}',
      edit: 'Rediger {{label}}',
      label: 'Indlejrede blokke',
      remove: 'Fjern {{label}}',
    },
    label: 'Blokke',
  },
  de: {
    inlineBlocks: {
      create: 'Erstelle {{label}}',
      edit: 'Bearbeite {{label}}',
      label: 'Inline-Blöcke',
      remove: 'Entferne {{label}}',
    },
    label: 'Blöcke',
  },
  en: {
    inlineBlocks: {
      create: 'Create {{label}}',
      edit: 'Edit {{label}}',
      label: 'Inline Blocks',
      remove: 'Remove {{label}}',
    },
    label: 'Blocks',
  },
  es: {
    inlineBlocks: {
      create: 'Crear {{label}}',
      edit: 'Editar {{label}}',
      label: 'Bloques en línea',
      remove: 'Eliminar {{label}}',
    },
    label: 'Bloques',
  },
  et: {
    inlineBlocks: {
      create: 'Loo {{label}}',
      edit: 'Muuda {{label}}',
      label: 'Sisseehitatud plokid',
      remove: 'Eemalda {{label}}',
    },
    label: 'Plokk',
  },
  fa: {
    inlineBlocks: {
      create: 'ایجاد {{label}}',
      edit: 'ویرایش {{label}}',
      label: 'بلوک‌های درون خطی',
      remove: 'حذف {{label}}',
    },
    label: 'بلوک ها',
  },
  fr: {
    inlineBlocks: {
      create: 'Créer {{label}}',
      edit: 'Modifier {{label}}',
      label: 'Blocs en ligne',
      remove: 'Supprimer {{label}}',
    },
    label: 'Blocs',
  },
  he: {
    inlineBlocks: {
      create: 'צור {{label}}',
      edit: 'ערוך {{label}}',
      label: 'בלוקים משורשרים',
      remove: 'הסר {{label}}',
    },
    label: 'חסימות',
  },
  hr: {
    inlineBlocks: {
      create: 'Stvori {{label}}',
      edit: 'Uredi {{label}}',
      label: 'Unutrašnji blokovi',
      remove: 'Ukloni {{label}}',
    },
    label: 'Blokovi',
  },
  hu: {
    inlineBlocks: {
      create: 'Hozzon létre {{label}}',
      edit: 'Szerkesztés {{label}}',
      label: 'Beágyazott blokkok',
      remove: 'Távolítsa el a {{label}}',
    },
    label: 'Blokkok',
  },
  is: {
    inlineBlocks: {
      create: 'Skrá {{label}}',
      edit: 'Breyta {{label}}',
      label: 'Línublokkir',
      remove: 'Fjarlægja {{label}}',
    },
    label: 'Blokkir',
  },
  it: {
    inlineBlocks: {
      create: 'Crea {{label}}',
      edit: 'Modifica {{label}}',
      label: 'Blocchi in linea',
      remove: 'Rimuovi {{label}}',
    },
    label: 'Blocchi',
  },
  ja: {
    inlineBlocks: {
      create: '{{label}}を作成する',
      edit: '{{label}}を編集する',
      label: 'インラインブロック',
      remove: '{{label}}を削除します',
    },
    label: 'ブロック',
  },
  ko: {
    inlineBlocks: {
      create: '{{label}} 생성하기',
      edit: '{{label}} 수정하기',
      label: '인라인 블록',
      remove: '{{label}} 제거하세요',
    },
    label: '블록',
  },
  my: {
    inlineBlocks: {
      create: 'Cipta {{label}}',
      edit: 'Sunting {{label}}',
      label: 'Inline Blocks [SKIPPED]',
      remove: 'Buang {{label}}',
    },
    label: 'တံတားများ',
  },
  nb: {
    inlineBlocks: {
      create: 'Opprett {{label}}',
      edit: 'Rediger {{label}}',
      label: 'In-line blokker',
      remove: 'Fjern {{label}}',
    },
    label: 'Blokker',
  },
  nl: {
    inlineBlocks: {
      create: 'Maak {{label}}',
      edit: 'Bewerk {{label}}',
      label: 'Inline Blocks',
      remove: 'Verwijder {{label}}',
    },
    label: 'Blokken',
  },
  pl: {
    inlineBlocks: {
      create: 'Utwórz {{label}}',
      edit: 'Edytuj {{label}}',
      label: 'Blokowanie w linii',
      remove: 'Usuń {{label}}',
    },
    label: 'Bloki',
  },
  pt: {
    inlineBlocks: {
      create: 'Crie {{label}}',
      edit: 'Editar {{label}}',
      label: 'Blocos em linha',
      remove: 'Remova {{label}}',
    },
    label: 'Blocos',
  },
  ro: {
    inlineBlocks: {
      create: 'Creează {{label}}',
      edit: 'Editați {{label}}',
      label: 'Blocuri in linie',
      remove: 'Ștergeți {{label}}',
    },
    label: 'Blocuri',
  },
  rs: {
    inlineBlocks: {
      create: 'Креирај {{label}}',
      edit: 'Измени {{label}}',
      label: 'Уметнути блокови',
      remove: 'Уклони {{label}}',
    },
    label: 'Блокови',
  },
  'rs-latin': {
    inlineBlocks: {
      create: 'Kreiraj {{label}}',
      edit: 'Izmeni {{label}}',
      label: 'Umetnuti blokovi',
      remove: 'Ukloni {{label}}',
    },
    label: 'Blokovi',
  },
  ru: {
    inlineBlocks: {
      create: 'Создать {{label}}',
      edit: 'Изменить {{label}}',
      label: 'Встроенные блоки',
      remove: 'Удалить {{label}}',
    },
    label: 'Блоки',
  },
  sk: {
    inlineBlocks: {
      create: 'Vytvorte {{label}}',
      edit: 'Upraviť {{label}}',
      label: 'Inline bloky',
      remove: 'Odstráňte {{label}}',
    },
    label: 'Bloky',
  },
  sl: {
    inlineBlocks: {
      create: 'Ustvari {{label}}',
      edit: 'Uredi {{label}}',
      label: 'Vrstični bloki',
      remove: 'Odstrani {{label}}',
    },
    label: 'Bloki',
  },
  sv: {
    inlineBlocks: {
      create: 'Skapa {{label}}',
      edit: 'Redigera {{label}}',
      label: 'Inbäddade block',
      remove: 'Ta bort {{label}}',
    },
    label: 'Block',
  },
  ta: {
    inlineBlocks: {
      create: '{{label}} உருவாக்கவும்',
      edit: '{{label}} திருத்தவும்',
      label: 'இன்லைன் தொகுதிகள்',
      remove: '{{label}} நீக்கவும்',
    },
    label: 'தொகுதிகள்',
  },
  th: {
    inlineBlocks: {
      create: 'สร้าง {{label}}',
      edit: 'แก้ไข {{label}}',
      label: 'บล็อกแบบอินไลน์',
      remove: 'ลบ {{label}}',
    },
    label: 'บล็อค',
  },
  tr: {
    inlineBlocks: {
      create: '{{label}} oluşturun',
      edit: "{{label}}'i düzenleyin",
      label: 'Satır İçi Bloklar',
      remove: '{{label}} kaldırın',
    },
    label: 'Bloklar',
  },
  uk: {
    inlineBlocks: {
      create: 'Створити {{label}}',
      edit: 'Редагувати {{label}}',
      label: 'Вбудовані блоки',
      remove: 'Видалити {{label}}',
    },
    label: 'Блоки',
  },
  vi: {
    inlineBlocks: {
      create: 'Tạo {{label}}',
      edit: 'Chỉnh sửa {{label}}',
      label: 'Khối nội tuyến',
      remove: 'Xóa {{label}}',
    },
    label: 'Khối',
  },
  zh: {
    inlineBlocks: {
      create: '创建{{label}}',
      edit: '编辑 {{label}}',
      label: '内联块',
      remove: '删除{{label}}',
    },
    label: '区块',
  },
  'zh-TW': {
    inlineBlocks: {
      create: '創建 {{label}}',
      edit: '編輯 {{label}}',
      label: '內聯區塊',
      remove: '移除 {{label}}',
    },
    label: '區塊',
  },
}
